import React from 'react';
import {Typography} from '@mui/material';
import {formatPrice} from 'app/components/entities/billing/base';
import {DataId, Sx} from 'app/types/common';

interface Props extends Sx, DataId {
  amount: number;
  alignment?: 'start' | 'end';
}

export default function InvoiceAmount({sx, dataId, amount, alignment = 'end'}: Props) {
  return (
    <Typography sx={sx} data-id={dataId} justifySelf={alignment} fontWeight={600}>
      {formatPrice(amount, 2)}
    </Typography>
  );
}
